import axiosInstance from "./axiosInstance";

const saleService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/sales/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    save: async (payload) => {
        try {
            const response = await axiosInstance.post('/sales/save', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    monthSales: async (payload) => {
        try {
            const response = await axiosInstance.get('/sales/monthsales', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchAllPatients: async () => {
        try {
            const response = await axiosInstance.get('/sale/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAllMedicinesSales: async () => {
        try {
            const response = await axiosInstance.get('/sale/medicine/medicine/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAllPSales: async () => {
        try {
            const response = await axiosInstance.get('/sale/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAllServicesSale: async () => {
        try {
            const response = await axiosInstance.get('/sale/medicine/services/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetServiceSalesByDate: async () => {
        try {
            const response = await axiosInstance.get('/sale/medicine/services/filter-by-date');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetServiceMedicinesByDate: async () => {
        try {
            const response = await axiosInstance.get('/sale/medicine/medicines/fetch-by-date');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/sales/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    updatePatient: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/sales/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        } 
    },
    
    fetchInvoiceSales: async () => {
        try {
            const response = await axiosInstance.get('/sales/invoicesales');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchPnl: async () => {
        try {
            const response = await axiosInstance.get('/pnl/total-medicine-services-sale');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchTodayProfit: async () => {
        try {
            const response = await axiosInstance.get('/sales/todayprofit');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchAllPharmacySales: async () => {
        try {
            const response = await axiosInstance.get('/pharmacySale/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchPharmacySalesById: async (id) => {
        try {
            const response = await axiosInstance.get('/pharmacySale/get/' + id);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

 };

export default saleService;
